/**
 * Tiny playback coordinator using a window CustomEvent. When one player
 * starts, it claims the audio "channel"; the other listens and pauses
 * itself to avoid double audio.
 */
const EVENT_NAME = "mt:playback-claim";

export function claimPlayback(source) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(EVENT_NAME, { detail: { source } })
  );
}

export function onPlaybackClaim(handler) {
  if (typeof window === "undefined") return () => {};
  const listener = (e) => handler(e.detail?.source);
  window.addEventListener(EVENT_NAME, listener);
  return () => window.removeEventListener(EVENT_NAME, listener);
}
